<template>
    <div id="listContainer">
        <div class="queryPanel">
            <div class="queryPanel_form" :class="{'queryPanel_form_show': showForm}">
                <Form
                    :form="queryForm"
                    @handleSelectChange="handleSelectChange"
                    @handlePressEnter="handlePressEnter"
                    @handleInputClear=handleInputClear
                    @handlePickerDateChange="handlePickerDateChange"
                ></Form>
            </div>
            <div class="queryPanel_btn">
                <a-dropdown-button size="small" @click="handle('search')">
                    <icon-search size="14" style="marginRight:5px;"/>
                    {{ $t('base.search') }}
                    <template #content>
                        <a-doption @click="handle('reset')">
                            <icon-refresh size="14" style="marginRight:5px;"/>
                            {{ $t('base.reset') }}
                        </a-doption>
                    </template>
                </a-dropdown-button>
            </div>
        </div>


        <Table 
            :table="table"
            @changePage="changePage"
            @changePageSize="changePageSize"
            @cellDblClick="cellDblClick"
        >
            <template v-slot:columns="{ props }">
                <div v-if="props.column.key == 'order_channel_type'">
                    <a-tag :color="props.record.order_channel_type_val == 1? 'green' : 'cyan' ">{{ props.record.order_channel_type }}</a-tag>
                </div>
                <div v-if="props.column.key == 'status'">
                    <a-tag :color="outboundStatusColor[props.record.status_val]">{{ props.record.status }}</a-tag>
                </div>
                <div v-if="props.column.key == 'frame_number'">
                    <div v-if="props.record.frame_number.length > 0">
                        <div v-for="(item,index) in props.record.frame_number" :key="index">
                            {{ item.FRAME_NUMBER }}
                        </div>
                    </div>
                    <div v-else>-</div>
                </div>
                <div v-if="props.column.key == 'quantity'">
                    <div>
                        <span style="display:inline-block;width:70px">{{ $t('invoice.orderQty') }}</span>：{{ props.record.quantity}}
                    </div>
                    <div>
                        <span style="display:inline-block;width:70px">{{ $t('invoice.shipQty') }}</span>：{{ props.record.ship_qty}}
                    </div>
                </div>
            </template>

            <template v-slot:tableOperate="{ props }">
                <!-- || (props.record.category_code === '627.501' && props.record.frame_number.length == 0) || (props.record.category_code === '627.501' && props.record.frame_number.length != props.record.quantity) -->
                <a-button 
                    v-permission="'setting.stock.edit'"  
                    type="primary" size="mini" :disabled="props.record.status_val == 1 || props.record.status_val == 3" 
                    style="margin-top:5px;width:92px" 
                    @click="handle('download',props.record)"
                >{{ $t('invoice.download') }}</a-button>
            </template>
        </Table>

    </div>
</template>

<script setup>
    import { onMounted, reactive, ref, watch, nextTick } from 'vue';
    import { InvoiceApi } from '@/api/InvoiceApi.js';
    import { OrderApi } from '@/api/OrderApi.js';
    import { PrepaidOrderApi } from '@/api/PrepaidOrderApi.js';
    import { Message, Modal } from '@arco-design/web-vue';
    import Table from '@/components/Table.vue';
    import Form from '@/components/Form.vue';
    import { InvoiceOutboundListQuery } from './queryConfig/InvoiceListQuery.js';
    import { useI18n } from 'vue-i18n';
    import { useLocale } from '@/store/index.js';
    import { dateToTimestamp, timestampToDate } from '@/utils/index.js';

    const { t } = useI18n()
    const localeStore = useLocale()

    const props = defineProps({
        visible:{
            type:Boolean,
            default:false,
        },
        invoiceType:{
            type:String,
            default:'',
        }
    })

    const visible = ref(false)
    const operateType = ref('add')
    const rowData = ref()
    const queryForm = reactive(InvoiceOutboundListQuery)
    const orderSource = reactive({})
    const columns = ref([
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'60',
                fixed:'left',
                align:'center',
            },
            {
                // title: '订单号',
                title: t('invoice.orderName'),
                dataIndex: 'order_name',
                key:'order_name',
                width:'120',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '出库单号',
                title: t('invoice.deliveryNumber'),
                dataIndex: 'delivery_number',
                key:'delivery_number',
                width:'160',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: 'sku',
                title: t('order.sku'),
                dataIndex: 'sku',
                key:'sku',
                width:'130',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '订单渠道类型',
                title: t('order.orderChannelType'),
                dataIndex: 'order_channel_type',
                key:'order_channel_type',
                width:'100',
                ellipsis:true,
                tooltip:true,
                slotName:'slot'
            },
            {
                // title: '出库状态',
                title:t('order.outboundStatus'),
                dataIndex: 'status',
                key:'status',
                width:'120',
                slotName: 'slot'
            },
            {
                // title: '订单车辆数和发货车辆数',
                title:t('invoice.quantity'),
                dataIndex: 'quantity',
                key:'quantity',
                width:'100',
                slotName: 'slot'
            }, 
            {
                // title: '车架号',
                title:t('order.frameNumber'),
                dataIndex: 'frame_number',
                key:'frame_number',
                width:'120',
                slotName: 'slot'
            }, 
            {
                // title: '创建日期',
                title:t('order.deliveryDate'),
                dataIndex: 'delivery_date',
                key:'delivery_date',
                width:'130',
                // align:'center',
            },
            {
                title: '操作',
                dataIndex: 'Optional',
                key:'Optional',
                slotName:'optional',
                width:'100',
                align:'center',
                fixed:'right'
            }
    ])
    const columns2 = ref([
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'60',
                fixed:'left',
                align:'center',
            },
            {
                // title: '订单号',
                title: t('invoice.orderName'),
                dataIndex: 'order_name',
                key:'order_name',
                width:'120',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '出库单号',
                title: t('invoice.deliveryNumber'),
                dataIndex: 'delivery_number',
                key:'delivery_number',
                width:'160',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '订单渠道类型',
                title: t('order.orderChannelType'),
                dataIndex: 'order_channel_type',
                key:'order_channel_type',
                width:'100',
                ellipsis:true,
                tooltip:true,
                slotName:'slot'
            },
            {
                // title: 'ERP编号',
                title:t('order.erpNo'),
                dataIndex: 'erp_no',
                key:'erp_no',
                width:'150',
                align:'left',
            },
            {
                // title: '订单时间',
                title:t('order.orderTimestamp'),
                dataIndex: 'order_timestamp',
                key:'order_timestamp',
                width:'140',
                align:'left',
                ellipsis:true,
                tooltip:true,
            },
            {
                title: '操作',
                dataIndex: 'Optional',
                key:'Optional',
                slotName:'optional',
                width:'100',
                align:'center',
                fixed:'right'
            }
    ]) 
    const table = ref({
        datas:[],
        columns:props.invoiceType == '1'? columns.value : columns2.value,
        configs:{
            scroll:{
                x:1200,
                y:540,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:{
                current:1,
                pageSize:10,
                total:0,
                pageSizeOptions:[10, 20, 50, 100],
                showJumper:true,
                showPageSize:true,
                showTotal:true,
            },
            
        },
    })

    const outboundStatusColor = ref({ // 出库状态
        1:'red',
        2:'green',
        3:'orange',
        4:'blue',
    })


    const handle = (type,row)=>{
        switch(type){
            case 'search':
                table.value.configs.pagination.current = 1
                getOutboundList()
                break;
            case 'reset':
                queryForm.formField.forEach(item=>{
                    queryForm.formData[item.key] = ''
                })
                table.value.configs.pagination.current = 1
                getOutboundList()
                break;
            case 'download':
                if(props.invoiceType == '1'){
                    validIsExistInvoice(row)
                }else{
                    downloadInvoice(row)
                }
                break;
        }
    }

    const changePage = (current)=>{
        table.value.configs.pagination.current = current
        getOutboundList()
    }

    const changePageSize = (pageSize)=>{
        table.value.configs.pagination.current = 1
        table.value.configs.pagination.pageSize = pageSize
        getOutboundList()
    }

    const handleSelectChange = (val,opt,key)=>{
        console.log(val,opt,key)
        table.value.configs.pagination.current = 1
        getOutboundList()
    }

    const handleInputClear = (val,item)=>{
        table.value.configs.pagination.current = 1
        getOutboundList()
    }

    const handlePressEnter = (val,item)=>{
        table.value.configs.pagination.current = 1
        getOutboundList()
    }

    // 获取出库单列表/预付款订单列表
    const getOutboundList = async ()=>{
        let param = {
            ...queryForm.formData,
            order_name:queryForm.formData.order_name.trim(),
            delivery_number:queryForm.formData.delivery_number.trim(),
            order_channel_type: queryForm.formData.order_channel_type,
        }
        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize
        table.value.configs.loading = true
        let res = props.invoiceType == '1'
                ? await InvoiceApi.getInstance().getOutboundList(param, page_num, page_size) 
                : await PrepaidOrderApi.getInstance().getPrepaidOrderList(param, page_num, page_size)
        if(res.code == 0){
            table.value.datas = []
            res.data.records.length > 0 && res.data.records.forEach((item,index)=>{
                table.value.datas.push({
                    ...item,
                    No: index + 1,
                    order_channel_type_val:item.order_channel_type,
                    order_channel_type: item.order_channel_type === 1? t('order.dealer') : t('order.c2c'),
                    status_val:item.status,
                    status: item.status == 1? t('invoice.unOutbound') : item.status == 2? t('invoice.outbound') : item.status == 3? t('invoice.cancelOutbound') : t('invoice.outScanned'),
                    delivery_date: item.delivery_date == undefined? '-' : timestampToDate(item.delivery_date * 1000),
                    frame_number: !item.frame_number? [] : item.frame_number,
                    order_timestamp: !item.order_timestamp? '-' : timestampToDate(item.order_timestamp * 1000).split(' ')[0],
                    delivery_number: !item.delivery_number? '-' : item.delivery_number,
                })
            })
            console.log(table.value.datas,'gggg')
            table.value.configs.pagination.total = res.data.total
            table.value.configs.pagination.current = res.data.current
            table.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 判断发票是否存在
    const validIsExistInvoice = async(row)=>{
        let delivery_number = row.delivery_number == '-'? '' : row.delivery_number
        let res = await InvoiceApi.getInstance().validIsExistInvoice(row.order_id, 1, delivery_number)
        if(res.code == 0){
            if(res.data.length == 0){
                downloadInvoice(row)
            }else{
                Modal.warning({
                    title: t('base.tip'),
                    titleAlign:'start',
                    hideCancel:true,
                    content: t('invoice.doubleInvoiceMsg'), //'该订单的发票已存在，如果想重新生成新的发票，请在发票列表操作',
                    okText:t('base.ok'),
                    onOk:()=>{}
                })
            }
        }else{
            Message.error(res.msg)
        }
    }

    // 下载发票
    const downloadInvoice = async (row)=>{
        let param = {
            order_number: row.order_name,
            invoice_type: 1,
            invoice_child_type: row.delivery_number,
        }
        table.value.configs.loading = true
        let res = props.invoiceType == '1'
                ? await InvoiceApi.getInstance().downloadInvoice(param) 
                : await InvoiceApi.getInstance().downloadPrepaidInvoice(row.id, {})

        if(!res.code){
            let blob = new Blob([res], {type: 'application/octet-stream'})
            let a = document.createElement('a')
            a.href = URL.createObjectURL(blob)
            a.download = `${row.order_name}.pdf`
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            URL.revokeObjectURL(a.href)
            document.body.removeChild(a)
            setTimeout(()=>{
                table.value.configs.loading = false
                Message.success(t('base.downloadSuccess'))
            },1500)
        }else{
            Message.error(res.msg)
            table.value.configs.loading = false
        }
    }

    
    // 获取订单来源类型 和 erp客户编码
    const getOrderSource = async ()=>{
        let res = await OrderApi.getInstance().getOrderSource({status:'A'})
        if(res.code == 0){
            res.data.length > 0 && res.data.forEach(i=>{
                orderSource[i.id] = i.id == 1? 'Shopify' : i.customer_name
            })
        }else{
            Message.error(res.msg)
        }
    }

    watch(()=>props.visible,(val)=>{
        console.log(val,'vvvv')
        if(val){
            queryForm.formData.status = 2
            getOutboundList()
        } 
    })


    onMounted(()=>{
        let item = queryForm.formField.find(i=> i.key == 'status')
        item.show = props.invoiceType == '1'
        queryForm.formData.order_channel_type = 1

        getOrderSource()
        getOutboundList()
        
    })

</script>

<style lang="less" scoped>

.queryPanel{
    display: flex;
    // margin-bottom:7px;
    padding:7px;
    background: #fff;
    border-bottom: 1px dashed #ccc;

    .queryPanel_form{
        display: flex;
        flex:14;
        flex-direction: column;
        height: 33px;
        overflow: hidden;

        /deep/ .arco-form-layout-inline .arco-form-item{
            margin-bottom:0;
        }
    }

    .queryPanel_form_show{
        height: auto;
        overflow: visible;
    }

    .queryPanel_btn{
        display: flex;
        flex:1;
        // flex-direction: column;
        justify-content: center;
        align-items: center;
        border-left:1px solid #eee;
        padding-left:5px;

        .openBtn{
            display: inline-block;
            padding: 3px 10px;
            margin: 2px 5px 0 5px;
            width: 80px;
            text-align: center;
            color: #165dff;
            cursor: pointer;
            border: 1px solid #165dff;
            border-radius:2px;
        }
    }

    /deep/ .arco-form-item-label-col > .arco-form-item-label{
        font-size:12px;
    }

    .form_btn{
        margin:5px 5px 3px;
        width:70px;
    }
}

/deep/ .operayeBox {
    margin-bottom: 7px;
    background: #fff;
    padding: 5px 24px 5px;
}

/deep/ .arco-btn-group{
    vertical-align: bottom;
}
/deep/ .arco-btn-group .arco-btn:first-child,
/deep/ .arco-btn-group .arco-btn:last-child{
    background: #165dff;
    color: #fff;
}

/deep/ .arco-picker-size-medium input,
/deep/ .arco-input-wrapper .arco-input.arco-input-size-medium,
/deep/ .arco-select-view-single.arco-select-view-size-medium .arco-select-view-input{
    font-size:12px;
}


/deep/ .arco-table-th{
    background: #fff;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    padding: 10px 0;
    font-weight: 600;
}

/deep/ .arco-table-container{
    padding-bottom: 0;
}

/deep/ .arco-table-td{
    padding: 10px 0;
    // border-bottom: none;
    border-right: 1px solid #eee;
}

/deep/ .arco-pagination-options .arco-select,
/deep/ .arco-pagination-jumper .arco-pagination-jumper-input input{
    background: #e7e7e7;
}

/deep/  button:focus,
/deep/  button:focus-visible{
    outline: none;
}


.addForm{
    /deep/ .arco-input-wrapper,
    /deep/ .arco-picker-size-medium{
        height: 45px;
    }

    /deep/ .arco-form-item-label-col{
        line-height: 45px;
    }
}

</style>